import { render, staticRenderFns } from "./CustomerVisitsDialog.vue?vue&type=template&id=8054cdc2&"
import script from "./CustomerVisitsDialog.vue?vue&type=script&lang=js&"
export * from "./CustomerVisitsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports